<template>
  <qx-card-form title="操作说明">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="40px">
      <section slot="split"></section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        orgIdOptions: [],
        inline: true,
        form: [
          {
            label: ' ',
            value: 'opRemarks',
            placeholder: '请填写本地址操作需要注意的事项',
            type: 'input',
            width: '690px',
            attr: {
              type: 'textarea',
              limit: 300,
            },
          },
        ],
      },
    };
  },
  methods: {

    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
        };
      }
      return formData;
    },
    async init (data = {}) {
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
